<template>
    <div class="row">
        <div class="section">
            <div class="container">
                <div class="slider">
                    <ul class="slides">
                        <li>
                            <img src="../../img/galeriaFotos/104.jpg"> <!-- random image -->
                            <div class="caption center-align">
                                <h3>Sala de Entretenimento!</h3>
                            </div>
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/041.jpg"> <!-- random image -->
                            <div class="caption left-align">
                                <h3>WIFI em todo Hotel!</h3>
                            </div>
                        </li>
                        <li>
                            <img src="../../img/galeriaFotos/021.jpg"> <!-- random image -->
                            <div class="caption left-align">
                                <h3>Café da Manhã!</h3>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card z-depth-2 hoverable">
                            <div class="card-content">
                                <span class="card-title">Serviços:</span>
                                <p>Oferecemos o melhor para o seu conforto !</p>
                                <ul>
                                    <li><i class="tiny ion-ios-pizza"></i> Lanches 24 horas</li>
                                    <li><i class="tiny ion-ios-cafe"></i> Café da Manhã</li>
                                    <li><i class="tiny ion-ios-car"></i> Estacionamento aéreo e subterrâneo</li>
                                    <li><i class="tiny ion-ios-water"></i> Lavanderia</li>
                                    <li><i class="tiny ion-ios-wifi"></i> Wi-Fi gratuito</li>
                                    <li><i class="tiny ion-ios-alarm"></i> Despertador</li>
                                    <li><i class="tiny ion-logo-windows"></i> Sala de Entretenimento com computador e tv</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    export default {
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-serv').addClass('active');

            $('.slider').slider();
            $('.materialboxed').materialbox();
        }
    };
</script>


// WEBPACK FOOTER //
// servicos.vue?dcf7d5ee